/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Remove_Team_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to remove {name} from this space?" |
*
* @param {Spaces_Remove_Team_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_remove_team_description = /** @type {((inputs: Spaces_Remove_Team_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Remove_Team_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bist du sicher, dass du ${i?.name} aus diesem Space entfernen möchtest?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to remove ${i?.name} from this space?`)
});